export default "__VITE_ASSET__DpZKNipb__"